import { render, staticRenderFns } from "./V2WishlistListModal.vue?vue&type=template&id=664e7f70&scoped=true&"
import script from "./V2WishlistListModal.vue?vue&type=script&lang=js&"
export * from "./V2WishlistListModal.vue?vue&type=script&lang=js&"
import style0 from "./V2WishlistListModal.vue?vue&type=style&index=0&id=664e7f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664e7f70",
  null
  
)

export default component.exports